// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {Fragment, useState} from 'react';
import {Editor} from '../../../shared/editor/editor';
import {Button} from '../../../shared/button';
import {get_img_url} from './utils';
import styles from './bounty_payments.module.less';

const check_src = 'bounty_small_check.svg';

export interface i_bounty_payments_props {
  title?: string;
  description?: string;
  items?: string[];
}

export const Bounty_payments = ({
  title,
  description,
  items=[],
}: i_bounty_payments_props)=>{
  return <section className={styles.bounty_payments}>
    <div className={styles.bounty_payments__inner}>
      <div className={styles.bounty_payments__heading}>
        {title&&<h3 className={styles.bounty_payments__title}>
          {title}
        </h3>}
        {description&&<p
          className={styles.bounty_payments__description}>
          {description}
        </p>}
      </div>
      {!!items.length&&<ul className={styles.bounty_payments__list}>
        {items.map((item, index)=><li
          key={`${item}-${index}`}
          className={styles.bounty_payments__item}>
          <span className={styles.bounty_payments__check_box}>
            <span
              className={styles.bounty_payments__check}
              style={{
                WebkitMaskImage: `url(${get_img_url(check_src)})`,
                maskImage: `url(${get_img_url(check_src)})`,
              }}
              aria-hidden="true"
            />
          </span>
          <span className={styles.bounty_payments__item_text}>
            {item}
          </span>
        </li>)}
      </ul>}
    </div>
  </section>;
};

interface i_bounty_payments_editor_props {
  value: i_bounty_payments_props;
  on_change: (value: i_bounty_payments_props)=>void;
  on_cancel?: ()=>void;
}

export const Bounty_payments_editor = (
  props: i_bounty_payments_editor_props
)=>{
  const [state, set_state] = useState<i_bounty_payments_props>({
    ...props.value,
    items: props.value?.items||[],
  });

  const items = state.items||[];

  const update_item = (index: number, value: string)=>{
    const next_items = [...items];
    next_items[index] = value;
    set_state({...state, items: next_items});
  };

  const delete_item = (index: number)=>{
    set_state({
      ...state,
      items: items.filter((_, item_index)=>item_index!=index),
    });
  };

  return <Editor<i_bounty_payments_props>
    value={state}
    editors={[
      {key: 'title', label: 'Title', type: 'text'},
      {key: 'description', label: 'Description', type: 'textarea'},
    ]}
    on_change={set_state}
    on_save={()=>props.on_change(state)}
    on_cancel={props.on_cancel}>
    <Fragment>
      <h4>Payment rules</h4>

      {items.map((item, index)=><div key={index}>
        <Editor<{text: string}>
          title={`Rule ${index+1}`}
          value={{text: item}}
          editors={[
            {key: 'text', label: 'Rule', type: 'textarea'},
          ]}
          on_change={(value: {text: string})=>
            update_item(index, value.text)}
        />

        <Button
          caption="Delete rule"
          size="xs"
          color="secondary"
          on_click={()=>delete_item(index)}
        />
        <hr/>
      </div>)}

      <Button
        caption="Add rule"
        size="xs"
        on_click={()=>set_state({
          ...state,
          items: [...items, ''],
        })}
      />
    </Fragment>
  </Editor>;
};
